import React, { useContext } from "react";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import { Divider, CircularProgress } from "@mui/material";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import Typography from "@mui/material/Typography";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { LoginViewContext } from "components/Login.page";
import LoginIcon from "images/loginIcon.png";
import { createTheme, ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import { Grid, Link } from "@mui/material";
import LoadingScreen from "components/common/LoadingScreen";
import LockPromptDialog from "components/common/LockPromptDialog";
import { Controller, useForm } from "react-hook-form";
import { useStyles } from "./Login.page.style";
import login_bg_mobile from "images/login_bg_mobile.png";
import NoticeDialog from "./NoticeDialog";
import { isGrayMode } from "constant";
const LoginMobile = () => {
	const {
		isLoading,
		theme,
		iptNotice,
		usefulInfo,
		logoLink,
		handleSubmit,
		onSubmit,
		control,
		email,
		setEmail,
		errors,
		password,
		setPassword,
		handleClickShowPassword,
		handleMouseDownPassword,
		showPassword,
		showLockTip,
		setShowLockTip,
		handleLockClose,
		lockTipContent,
		setErrMsg,
		isError,
		loginRemainTime,
	} = useContext(LoginViewContext);

	const classes = useStyles();

	const [noticeOpen, setNoticeOpen] = React.useState(false);

	React.useEffect(() => {
		if (Array.isArray(iptNotice) && iptNotice.length > 0) {
			setNoticeOpen(true);
		}
	}, [iptNotice]);
	React.useEffect(() => {
		if (errors.email?.message) {
			setErrMsg(errors.email?.message);
		}
	}, [errors.email]);
	React.useEffect(() => {
		if (errors.pwd?.message) {
			setErrMsg(errors.pwd?.message);
		}
	}, [errors.pwd]);

	return (
		<div
			className={isGrayMode() ? classes.grayscaleLogin : ""}
			style={{ height: "100%", overflow: "hidden", position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
		>
			<div style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
				<LoadingScreen open={isLoading} />
				<StyledEngineProvider injectFirst>
					<ThemeProvider theme={theme}>
						<Grid container className={classes.fullHeight} flexWrap={"nowrap"}>
							<Grid container item>
								<span className={classes.blueRound} />
								<span className={classes.yellowRound} />
								<Grid container direction="column">
									<Grid container>
										<div>
											<img width="75%" src={login_bg_mobile} />
										</div>
									</Grid>
									{/* <Grid container>
                                    </Grid> */}
									<div>
										<a href={logoLink} target={"_blank"}>
											<img
												style={{ maxWidth: "100%" }}
												src={LoginIcon}
												alt={"icon"}
												className={classes.loginIcon}
											/>
										</a>
									</div>
									{/* <Grid container className={classes.iconDivider}></Grid> */}
									<form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
										<Grid container direction={"column"} className={classes.loginFormContainer}>
											<Grid item style={{ lineHeight: 1.1 }}>
												<div className={classes.welcomeFont}>Welcome to EHP</div>
												<div className={classes.welcomeFont}>
													Data Collaboration Laboratory Portal
													{process.env.REACT_APP_ENV_DESC || ""}
												</div>
											</Grid>
											<Grid item container direction={"column"} className={classes.loginInputBox}>
												<Grid item className={classes.loginFont}>
													LOGIN
												</Grid>
												<Grid item className={classes.LoginInputWrapper}>
													<FormControl fullWidth>
														<FormLabel htmlFor="email" className={classes.blackColor}>
															Email
														</FormLabel>
														<Controller
															render={({ field }) => (
																<TextField
																	{...field}
																	error={!!errors?.email}
																	helperText={errors?.email?.message}
																	variant="standard"
																	InputProps={{
																		className: classes.inputStyle,
																	}}
																	inputProps={{ maxLength: 128 }}
																/>
															)}
															id={"email"}
															name="email"
															control={control}
															rules={{
																required: true,
															}}
															fullWidth={true}
														/>
													</FormControl>
												</Grid>
												<Grid item className={classes.loginPwdInputWrapper}>
													<FormControl fullWidth>
														<FormLabel htmlFor="password" className={classes.blackColor}>
															Password
														</FormLabel>
														<Controller
															render={({ field }) => (
																<TextField
																	{...field}
																	type={showPassword ? "text" : "password"}
																	error={!!errors.pwd}
																	helperText={errors.pwd?.message}
																	style={{ height: "30px" }}
																	variant="standard"
																	InputProps={{
																		className: classes.inputStyle,
																		endAdornment: (
																			<InputAdornment position="end">
																				<IconButton
																					aria-label="toggle password visibility"
																					onClick={handleClickShowPassword}
																					onMouseDown={
																						handleMouseDownPassword
																					}
																					style={{ color: "black" }}
																					size="large"
																				>
																					{showPassword ? (
																						<Visibility />
																					) : (
																						<VisibilityOff />
																					)}
																				</IconButton>
																			</InputAdornment>
																		),
																	}}
																	inputProps={{
																		maxLength: 48,
																		style: {
																			fontFamily:
																				showPassword || "text-security-disc",
																		},
																	}}
																/>
															)}
															control={control}
															rules={{
																required: true,
															}}
															id="pwd"
															name="pwd"
														/>
													</FormControl>
												</Grid>
												<Grid item className={classes.LoginInputWrapper}>
													<FormControl>
														<Button
															type="submit"
															variant="contained"
															color="primary"
															style={{
																textTransform: "none",
																fontFamily: "Quicksand-SemiBold",
																fontSize: 16,
															}}
															disabled={loginRemainTime > 0}
														>
															Login
															{loginRemainTime > 0 ? (
																<CircularProgress size={16} />
															) : null}
														</Button>
													</FormControl>
												</Grid>
											</Grid>
										</Grid>
									</form>
									<Grid container direction="column" alignItems="center" style={{ marginTop: 12 }}>
										<Grid item>
											<Link
												href={"/forgotPswSendEmail"}
												underline="none"
												style={{ cursor: "pointer", fontSize: 16 }}
											>
												Forget Password?
											</Link>
										</Grid>
										<Grid item style={{ textAlign: "center", marginTop: 8 }}>
											<div style={{ lineHeight: "1.2" }}>Don't have an account?</div>
											<Link
												href={"/signup"}
												underline="none"
												style={{ cursor: "pointer", fontSize: 16 }}
											>
												Sign up now
											</Link>
										</Grid>
									</Grid>
									<Grid container style={{ flex: 1, minHeight: 90, position: "relative" }}>
										<div
											className={classes.InfoWrapper}
											style={{ position: "absolute", top: 0, left: 0, height: "100%" }}
										>
											<Typography color={"primary"} className={classes.titleFont}>
												USEFUL INFORMATION
											</Typography>
											<Divider className={classes.InfoDivider} />
											<div className={classes.InfoContainer}>
												{Array.isArray(usefulInfo) &&
													usefulInfo.length > 0 &&
													usefulInfo.map((item, index) => (
														<div
															key={index}
															dangerouslySetInnerHTML={{ __html: item.content }}
														></div>
													))}
											</div>
										</div>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</ThemeProvider>
				</StyledEngineProvider>
				<NoticeDialog
					open={noticeOpen}
					onClose={() => setNoticeOpen(false)}
					content={
						<div className={classes.InfoContainer} style={{ maxHeight: 300 }}>
							{Array.isArray(iptNotice) &&
								iptNotice.length > 0 &&
								iptNotice.map((item, index) => (
									<div key={index} dangerouslySetInnerHTML={{ __html: item.content }}></div>
								))}
						</div>
					}
				/>
				<LockPromptDialog open={showLockTip} onClose={handleLockClose || (() => setShowLockTip(false))} content={lockTipContent} />
			</div>
		</div>
	);
};

export default LoginMobile;
